// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════
   CALENDAR — Modern SaaS Override
   Prefixed with .schedule-calendar for specificity
   ═══════════════════════════════════════════════ */

/* ── Toolbar ─────────────────────────────────── */
.schedule-calendar .rbc-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px !important;
  margin-bottom: 12px !important;
  border-radius: 12px !important;
  background: var(--rbc-toolbar-bg, rgba(255,255,255,0.92)) !important;
  border: 1px solid var(--rbc-border, rgba(15,23,42,0.08)) !important;
  box-shadow: 0 2px 8px rgba(15,23,42,0.05) !important;
  font-size: 13px !important;
}

.schedule-calendar .rbc-toolbar .rbc-toolbar-label {
  font-size: 0.95rem !important;
  font-weight: 700 !important;
  letter-spacing: -0.1px !important;
  flex-grow: 1 !important;
  text-align: center !important;
}

/* Reset default btn group margins */
.schedule-calendar .rbc-btn-group {
  display: flex;
  align-items: center;
  gap: 2px;
  white-space: nowrap;
}

.schedule-calendar .rbc-btn-group button + button {
  margin-left: 0 !important;
}

/* All toolbar buttons */
.schedule-calendar .rbc-toolbar button {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 32px !important;
  padding: 0 12px !important;
  border-radius: 8px !important;
  border: 1px solid transparent !important;
  background: transparent !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.1px !important;
  color: inherit !important;
  cursor: pointer !important;
  transition: background 0.15s ease, box-shadow 0.15s ease !important;
  box-shadow: none !important;
  white-space: nowrap !important;
}

.schedule-calendar .rbc-toolbar button:hover {
  background: rgba(99,102,241,0.08) !important;
  border-color: rgba(99,102,241,0.15) !important;
  color: inherit !important;
}

.schedule-calendar .rbc-toolbar button.rbc-active,
.schedule-calendar .rbc-toolbar button:active {
  background: #4f46e5 !important;
  border-color: #4f46e5 !important;
  color: #fff !important;
  box-shadow: 0 4px 12px rgba(79,70,229,0.28) !important;
  background-image: none !important;
}

.schedule-calendar .rbc-toolbar button.rbc-active:hover {
  background: #4338ca !important;
  border-color: #4338ca !important;
  color: #fff !important;
}

/* First/last btn in group — keep individual radius */
.schedule-calendar .rbc-btn-group > button:first-child:not(:last-child) {
  border-radius: 8px !important;
}
.schedule-calendar .rbc-btn-group > button:last-child:not(:first-child) {
  border-radius: 8px !important;
}
.schedule-calendar .rbc-btn-group > button:not(:first-child):not(:last-child) {
  border-radius: 8px !important;
}

/* ── Month view grid ─────────────────────────── */
.schedule-calendar .rbc-month-view {
  border-radius: 12px !important;
  border: 1px solid rgba(15,23,42,0.08) !important;
  overflow: hidden !important;
  background: #fff !important;
}

.schedule-calendar .rbc-month-row + .rbc-month-row {
  border-top: 1px solid rgba(15,23,42,0.06) !important;
}

.schedule-calendar .rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid rgba(15,23,42,0.06) !important;
}

/* Day headers (Mon, Tue…) */
.schedule-calendar .rbc-header {
  padding: 10px 6px !important;
  font-size: 0.68rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.8px !important;
  text-transform: uppercase !important;
  color: rgba(100,116,139,0.9) !important;
  background: rgba(248,250,252,0.95) !important;
  border-bottom: 1px solid rgba(15,23,42,0.07) !important;
}

.schedule-calendar .rbc-header + .rbc-header {
  border-left: 1px solid rgba(15,23,42,0.06) !important;
}

/* Date number cell */
.schedule-calendar .rbc-date-cell {
  padding: 5px 7px 2px !important;
  text-align: right !important;
}

.schedule-calendar .rbc-date-cell .rbc-button-link {
  font-size: 0.78rem !important;
  font-weight: 500 !important;
  color: #475569 !important;
  border-radius: 6px !important;
  padding: 2px 5px !important;
  transition: background 0.12s ease !important;
}

.schedule-calendar .rbc-date-cell .rbc-button-link:hover {
  background: rgba(99,102,241,0.08) !important;
  color: #4f46e5 !important;
}

/* Today */
.schedule-calendar .rbc-today {
  background: rgba(238,242,255,0.6) !important;
}

.schedule-calendar .rbc-today .rbc-button-link {
  background: #4f46e5 !important;
  color: #fff !important;
  font-weight: 700 !important;
  border-radius: 6px !important;
  padding: 2px 5px !important;
}

/* Off-range days (prev/next month) */
.schedule-calendar .rbc-off-range-bg {
  background: rgba(248,250,252,0.7) !important;
}

.schedule-calendar .rbc-off-range .rbc-button-link {
  color: #cbd5e1 !important;
}

/* Row segment padding */
.schedule-calendar .rbc-row-segment {
  padding: 1px 3px 2px !important;
}

/* ── Events ──────────────────────────────────── */
.schedule-calendar .rbc-event,
.schedule-calendar .rbc-day-slot .rbc-background-event {
  border: none !important;
  border-radius: 6px !important;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%) !important;
  box-shadow: 0 2px 6px rgba(79,70,229,0.25) !important;
  color: #fff !important;
  padding: 3px 7px !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  transition: transform 0.14s ease, box-shadow 0.14s ease !important;
  cursor: pointer !important;
}

.schedule-calendar .rbc-event:hover,
.schedule-calendar .rbc-day-slot .rbc-background-event:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 14px rgba(79,70,229,0.32) !important;
}

.schedule-calendar .rbc-event:focus {
  outline: none !important;
  box-shadow: 0 0 0 3px rgba(79,70,229,0.3) !important;
}

.schedule-calendar .rbc-event.rbc-selected {
  background: linear-gradient(135deg, #4338ca 0%, #3730a3 100%) !important;
  box-shadow: 0 6px 16px rgba(79,70,229,0.4) !important;
}

/* Variant override by status */
.schedule-calendar .rbc-event.schedule-event-sent {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%) !important;
  box-shadow: 0 2px 6px rgba(22,163,74,0.28) !important;
}

.schedule-calendar .rbc-event.schedule-event-sent:hover {
  box-shadow: 0 6px 14px rgba(22,163,74,0.35) !important;
}

.schedule-calendar .rbc-event.schedule-event-sent.rbc-selected {
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%) !important;
  box-shadow: 0 6px 16px rgba(21,128,61,0.38) !important;
}

.schedule-calendar .rbc-day-slot .rbc-event {
  border: none !important;
  border-left: 3px solid rgba(255,255,255,0.4) !important;
  overflow: visible !important;
}

/* Show more */
.schedule-calendar .rbc-show-more {
  font-size: 0.69rem !important;
  font-weight: 700 !important;
  color: #4f46e5 !important;
  background: transparent !important;
  padding: 2px 6px !important;
  border-radius: 4px !important;
}

.schedule-calendar .rbc-show-more:hover {
  background: rgba(79,70,229,0.08) !important;
  color: #4338ca !important;
}

/* ── Event container (custom title) ─────────── */
.schedule-calendar .event-container {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 5px;
}

.schedule-calendar .event-title {
  font-size: 0.73rem;
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 1 1;
  letter-spacing: 0.1px;
}

.schedule-calendar .delete-icon,
.schedule-calendar .edit-icon {
  opacity: 0;
  transition: opacity 0.15s ease, transform 0.15s ease;
  transform: translateY(2px);
  font-size: 15px !important;
  flex-shrink: 0;
}

.schedule-calendar .event-container:hover .delete-icon,
.schedule-calendar .event-container:hover .edit-icon {
  opacity: 0.9;
  transform: translateY(0);
}

/* Week/Day views: trigger icons when hovering the event badge itself */
.schedule-calendar .rbc-event:hover .delete-icon,
.schedule-calendar .rbc-event:hover .edit-icon,
.schedule-calendar .rbc-day-slot .rbc-event:hover .delete-icon,
.schedule-calendar .rbc-day-slot .rbc-event:hover .edit-icon {
  opacity: 0.9;
  transform: translateY(0);
}

/* Keep icons visible inside tighter event wrappers used in time views */
.schedule-calendar .rbc-event-content {
  overflow: visible !important;
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
}

/* Week/Day: ensure icons are not clipped and can appear on hover */
.schedule-calendar .rbc-time-view .rbc-event {
  overflow: visible !important;
}

.schedule-calendar .rbc-time-view .event-container {
  width: 100%;
}

.schedule-calendar .rbc-time-view .event-title {
  min-width: 0;
}

.schedule-calendar .rbc-time-view .rbc-event:hover .delete-icon,
.schedule-calendar .rbc-time-view .rbc-event:hover .edit-icon {
  opacity: 0.95 !important;
  transform: translateY(0) !important;
}

.schedule-calendar .delete-icon:hover,
.schedule-calendar .edit-icon:hover {
  opacity: 1 !important;
}

/* ── Time View ────────────────────────────────── */
.schedule-calendar .rbc-time-view {
  border-radius: 12px !important;
  border: 1px solid rgba(15,23,42,0.08) !important;
  overflow: hidden !important;
  background: #fff !important;
}

.schedule-calendar .rbc-time-view .rbc-allday-cell + .rbc-allday-cell {
  border-left: 1px solid rgba(15,23,42,0.06) !important;
}

.schedule-calendar .rbc-time-header {
  border-bottom: 1px solid rgba(15,23,42,0.07) !important;
  background: rgba(248,250,252,0.98) !important;
}

.schedule-calendar .rbc-time-header-content {
  border-left: 1px solid rgba(15,23,42,0.06) !important;
}

.schedule-calendar .rbc-time-header > .rbc-row:first-child {
  border-bottom: 1px solid rgba(15,23,42,0.07) !important;
}

.schedule-calendar .rbc-timeslot-group {
  border-bottom: 1px solid rgba(15,23,42,0.05) !important;
  min-height: 44px !important;
}

.schedule-calendar .rbc-time-slot {
  font-size: 0.68rem !important;
  color: #94a3b8 !important;
  font-weight: 500 !important;
}

.schedule-calendar .rbc-day-slot .rbc-time-slot {
  border-top: 1px solid rgba(15,23,42,0.04) !important;
}

.schedule-calendar .rbc-time-content {
  border-top: 1px solid rgba(15,23,42,0.07) !important;
}

.schedule-calendar .rbc-time-content > * + * > * {
  border-left: 1px solid rgba(15,23,42,0.06) !important;
}

.schedule-calendar .rbc-label {
  padding: 0 10px !important;
}

/* Current time indicator */
.schedule-calendar .rbc-current-time-indicator {
  height: 2px !important;
  background: #f63d68 !important;
  opacity: 0.85 !important;
}

/* ── Agenda View ──────────────────────────────── */
.schedule-calendar .rbc-agenda-view {
  border-radius: 12px !important;
  overflow: hidden !important;
}

.schedule-calendar .rbc-agenda-view table.rbc-agenda-table {
  border: 1px solid rgba(15,23,42,0.08) !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
}

.schedule-calendar .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  padding: 10px 14px !important;
  font-size: 0.68rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.8px !important;
  text-transform: uppercase !important;
  color: #94a3b8 !important;
  background: rgba(248,250,252,0.98) !important;
  border-bottom: 1px solid rgba(15,23,42,0.07) !important;
}

.schedule-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
  padding: 10px 14px !important;
  font-size: 0.82rem !important;
  vertical-align: middle !important;
  border-bottom: 1px solid rgba(15,23,42,0.05) !important;
}

.schedule-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left: 1px solid rgba(15,23,42,0.05) !important;
}

.schedule-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {
  border-top: none !important;
}

.schedule-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr:hover > td {
  background: rgba(99,102,241,0.04) !important;
}

.schedule-calendar .rbc-agenda-date-cell {
  font-weight: 700 !important;
  font-size: 0.78rem !important;
  color: #334155 !important;
  white-space: nowrap !important;
}

.schedule-calendar .rbc-agenda-time-cell {
  font-size: 0.75rem !important;
  color: #334155 !important;
  font-weight: 600 !important;
  white-space: nowrap !important;
  text-transform: none !important;
}

.schedule-calendar .rbc-agenda-event-cell {
  width: 100% !important;
}

.schedule-calendar .rbc-agenda-event-cell .rbc-event {
  color: #ffffff !important;
}

.schedule-calendar .rbc-agenda-event-cell .event-title {
  color: #ffffff !important;
}

/* "Não há agendamentos" empty state */
.schedule-calendar .rbc-agenda-empty {
  padding: 32px !important;
  text-align: center !important;
  font-size: 0.85rem !important;
  color: #94a3b8 !important;
}

/* ── Overlay (popup for +N more) ─────────────── */
.schedule-calendar .rbc-overlay {
  border-radius: 12px !important;
  border: 1px solid rgba(15,23,42,0.1) !important;
  box-shadow: 0 16px 40px rgba(15,23,42,0.14) !important;
  padding: 10px !important;
  background: #fff !important;
}

.schedule-calendar .rbc-overlay-header {
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  padding: 4px 8px 8px !important;
  border-bottom: 1px solid rgba(15,23,42,0.07) !important;
  margin: -8px -8px 8px !important;
  color: #475569 !important;
}

/* ── Mobile ───────────────────────────────────── */
@media (hover: none), (pointer: coarse) {
  .schedule-calendar .delete-icon,
  .schedule-calendar .edit-icon {
    opacity: 0.9;
    transform: translateY(0);
  }

  .schedule-calendar .event-title {
    font-size: 0.7rem;
  }
}

@media (max-width: 599px) {
  .schedule-calendar .rbc-toolbar {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 6px !important;
  }

  .schedule-calendar .rbc-toolbar .rbc-toolbar-label {
    order: -1 !important;
    font-size: 0.88rem !important;
  }

  .schedule-calendar .rbc-btn-group {
    justify-content: center !important;
    flex-wrap: wrap !important;
  }

  .schedule-calendar .rbc-toolbar button {
    height: 30px !important;
    padding: 0 9px !important;
    font-size: 0.7rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Schedules/Schedules.css"],"names":[],"mappings":"AAAA;;;oDAGoD;;AAEpD,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,oEAAoE;EACpE,mEAAmE;EACnE,oDAAoD;EACpD,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,wCAAwC;EACxC,kCAAkC;EAClC,6BAA6B;EAC7B,2BAA2B;EAC3B,gCAAgC;EAChC,yBAAyB;EACzB,0BAA0B;EAC1B,mEAAmE;EACnE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;EACtB,sDAAsD;EACtD,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,qDAAqD;AACrD;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;;AAEA,mDAAmD;AACnD;EACE,8BAA8B;EAC9B,gDAAgD;EAChD,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,qDAAqD;AACvD;;AAEA,4BAA4B;AAC5B;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,gCAAgC;EAChC,oCAAoC;EACpC,uCAAuC;EACvC,6CAA6C;EAC7C,uDAAuD;AACzD;;AAEA;EACE,qDAAqD;AACvD;;AAEA,qBAAqB;AACrB;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,+BAA+B;AACjC;;AAEA,mDAAmD;AACnD;;EAEE,uBAAuB;EACvB,6BAA6B;EAC7B,wEAAwE;EACxE,qDAAqD;EACrD,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,kEAAkE;EAClE,0BAA0B;AAC5B;;AAEA;;EAEE,sCAAsC;EACtC,sDAAsD;AACxD;;AAEA;EACE,wBAAwB;EACxB,oDAAoD;AACtD;;AAEA;EACE,wEAAwE;EACxE,qDAAqD;AACvD;;AAEA,+BAA+B;AAC/B;EACE,wEAAwE;EACxE,qDAAqD;AACvD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,wEAAwE;EACxE,sDAAsD;AACxD;;AAEA;EACE,uBAAuB;EACvB,uDAAuD;EACvD,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,kCAAkC;EAClC,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;EACV,oDAAoD;EACpD,0BAA0B;EAC1B,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA,uEAAuE;AACvE;;;;EAIE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA,wEAAwE;AACxE;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,oDAAoD;AACpD;EACE,8BAA8B;EAC9B,gDAAgD;EAChD,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,uDAAuD;EACvD,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,uDAAuD;EACvD,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA,oDAAoD;AACpD;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;EAChD,8BAA8B;EAC9B,2BAA2B;EAC3B,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,gCAAgC;EAChC,oCAAoC;EACpC,yBAAyB;EACzB,6CAA6C;EAC7C,uDAAuD;AACzD;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,iCAAiC;EACjC,uDAAuD;AACzD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,8BAA8B;EAC9B,+CAA+C;EAC/C,sDAAsD;EACtD,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;EAC/B,uDAAuD;EACvD,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,oDAAoD;AACpD;EACE;;IAEE,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,6BAA6B;EAC/B;;EAEA;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;EAC9B;AACF","sourcesContent":["/* ═══════════════════════════════════════════════\n   CALENDAR — Modern SaaS Override\n   Prefixed with .schedule-calendar for specificity\n   ═══════════════════════════════════════════════ */\n\n/* ── Toolbar ─────────────────────────────────── */\n.schedule-calendar .rbc-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px !important;\n  margin-bottom: 12px !important;\n  border-radius: 12px !important;\n  background: var(--rbc-toolbar-bg, rgba(255,255,255,0.92)) !important;\n  border: 1px solid var(--rbc-border, rgba(15,23,42,0.08)) !important;\n  box-shadow: 0 2px 8px rgba(15,23,42,0.05) !important;\n  font-size: 13px !important;\n}\n\n.schedule-calendar .rbc-toolbar .rbc-toolbar-label {\n  font-size: 0.95rem !important;\n  font-weight: 700 !important;\n  letter-spacing: -0.1px !important;\n  flex-grow: 1 !important;\n  text-align: center !important;\n}\n\n/* Reset default btn group margins */\n.schedule-calendar .rbc-btn-group {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  white-space: nowrap;\n}\n\n.schedule-calendar .rbc-btn-group button + button {\n  margin-left: 0 !important;\n}\n\n/* All toolbar buttons */\n.schedule-calendar .rbc-toolbar button {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  height: 32px !important;\n  padding: 0 12px !important;\n  border-radius: 8px !important;\n  border: 1px solid transparent !important;\n  background: transparent !important;\n  font-size: 0.75rem !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.1px !important;\n  color: inherit !important;\n  cursor: pointer !important;\n  transition: background 0.15s ease, box-shadow 0.15s ease !important;\n  box-shadow: none !important;\n  white-space: nowrap !important;\n}\n\n.schedule-calendar .rbc-toolbar button:hover {\n  background: rgba(99,102,241,0.08) !important;\n  border-color: rgba(99,102,241,0.15) !important;\n  color: inherit !important;\n}\n\n.schedule-calendar .rbc-toolbar button.rbc-active,\n.schedule-calendar .rbc-toolbar button:active {\n  background: #4f46e5 !important;\n  border-color: #4f46e5 !important;\n  color: #fff !important;\n  box-shadow: 0 4px 12px rgba(79,70,229,0.28) !important;\n  background-image: none !important;\n}\n\n.schedule-calendar .rbc-toolbar button.rbc-active:hover {\n  background: #4338ca !important;\n  border-color: #4338ca !important;\n  color: #fff !important;\n}\n\n/* First/last btn in group — keep individual radius */\n.schedule-calendar .rbc-btn-group > button:first-child:not(:last-child) {\n  border-radius: 8px !important;\n}\n.schedule-calendar .rbc-btn-group > button:last-child:not(:first-child) {\n  border-radius: 8px !important;\n}\n.schedule-calendar .rbc-btn-group > button:not(:first-child):not(:last-child) {\n  border-radius: 8px !important;\n}\n\n/* ── Month view grid ─────────────────────────── */\n.schedule-calendar .rbc-month-view {\n  border-radius: 12px !important;\n  border: 1px solid rgba(15,23,42,0.08) !important;\n  overflow: hidden !important;\n  background: #fff !important;\n}\n\n.schedule-calendar .rbc-month-row + .rbc-month-row {\n  border-top: 1px solid rgba(15,23,42,0.06) !important;\n}\n\n.schedule-calendar .rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid rgba(15,23,42,0.06) !important;\n}\n\n/* Day headers (Mon, Tue…) */\n.schedule-calendar .rbc-header {\n  padding: 10px 6px !important;\n  font-size: 0.68rem !important;\n  font-weight: 800 !important;\n  letter-spacing: 0.8px !important;\n  text-transform: uppercase !important;\n  color: rgba(100,116,139,0.9) !important;\n  background: rgba(248,250,252,0.95) !important;\n  border-bottom: 1px solid rgba(15,23,42,0.07) !important;\n}\n\n.schedule-calendar .rbc-header + .rbc-header {\n  border-left: 1px solid rgba(15,23,42,0.06) !important;\n}\n\n/* Date number cell */\n.schedule-calendar .rbc-date-cell {\n  padding: 5px 7px 2px !important;\n  text-align: right !important;\n}\n\n.schedule-calendar .rbc-date-cell .rbc-button-link {\n  font-size: 0.78rem !important;\n  font-weight: 500 !important;\n  color: #475569 !important;\n  border-radius: 6px !important;\n  padding: 2px 5px !important;\n  transition: background 0.12s ease !important;\n}\n\n.schedule-calendar .rbc-date-cell .rbc-button-link:hover {\n  background: rgba(99,102,241,0.08) !important;\n  color: #4f46e5 !important;\n}\n\n/* Today */\n.schedule-calendar .rbc-today {\n  background: rgba(238,242,255,0.6) !important;\n}\n\n.schedule-calendar .rbc-today .rbc-button-link {\n  background: #4f46e5 !important;\n  color: #fff !important;\n  font-weight: 700 !important;\n  border-radius: 6px !important;\n  padding: 2px 5px !important;\n}\n\n/* Off-range days (prev/next month) */\n.schedule-calendar .rbc-off-range-bg {\n  background: rgba(248,250,252,0.7) !important;\n}\n\n.schedule-calendar .rbc-off-range .rbc-button-link {\n  color: #cbd5e1 !important;\n}\n\n/* Row segment padding */\n.schedule-calendar .rbc-row-segment {\n  padding: 1px 3px 2px !important;\n}\n\n/* ── Events ──────────────────────────────────── */\n.schedule-calendar .rbc-event,\n.schedule-calendar .rbc-day-slot .rbc-background-event {\n  border: none !important;\n  border-radius: 6px !important;\n  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%) !important;\n  box-shadow: 0 2px 6px rgba(79,70,229,0.25) !important;\n  color: #fff !important;\n  padding: 3px 7px !important;\n  font-size: 0.75rem !important;\n  font-weight: 600 !important;\n  transition: transform 0.14s ease, box-shadow 0.14s ease !important;\n  cursor: pointer !important;\n}\n\n.schedule-calendar .rbc-event:hover,\n.schedule-calendar .rbc-day-slot .rbc-background-event:hover {\n  transform: translateY(-1px) !important;\n  box-shadow: 0 6px 14px rgba(79,70,229,0.32) !important;\n}\n\n.schedule-calendar .rbc-event:focus {\n  outline: none !important;\n  box-shadow: 0 0 0 3px rgba(79,70,229,0.3) !important;\n}\n\n.schedule-calendar .rbc-event.rbc-selected {\n  background: linear-gradient(135deg, #4338ca 0%, #3730a3 100%) !important;\n  box-shadow: 0 6px 16px rgba(79,70,229,0.4) !important;\n}\n\n/* Variant override by status */\n.schedule-calendar .rbc-event.schedule-event-sent {\n  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%) !important;\n  box-shadow: 0 2px 6px rgba(22,163,74,0.28) !important;\n}\n\n.schedule-calendar .rbc-event.schedule-event-sent:hover {\n  box-shadow: 0 6px 14px rgba(22,163,74,0.35) !important;\n}\n\n.schedule-calendar .rbc-event.schedule-event-sent.rbc-selected {\n  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%) !important;\n  box-shadow: 0 6px 16px rgba(21,128,61,0.38) !important;\n}\n\n.schedule-calendar .rbc-day-slot .rbc-event {\n  border: none !important;\n  border-left: 3px solid rgba(255,255,255,0.4) !important;\n  overflow: visible !important;\n}\n\n/* Show more */\n.schedule-calendar .rbc-show-more {\n  font-size: 0.69rem !important;\n  font-weight: 700 !important;\n  color: #4f46e5 !important;\n  background: transparent !important;\n  padding: 2px 6px !important;\n  border-radius: 4px !important;\n}\n\n.schedule-calendar .rbc-show-more:hover {\n  background: rgba(79,70,229,0.08) !important;\n  color: #4338ca !important;\n}\n\n/* ── Event container (custom title) ─────────── */\n.schedule-calendar .event-container {\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  gap: 5px;\n}\n\n.schedule-calendar .event-title {\n  font-size: 0.73rem;\n  font-weight: 600;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  flex: 1;\n  letter-spacing: 0.1px;\n}\n\n.schedule-calendar .delete-icon,\n.schedule-calendar .edit-icon {\n  opacity: 0;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n  transform: translateY(2px);\n  font-size: 15px !important;\n  flex-shrink: 0;\n}\n\n.schedule-calendar .event-container:hover .delete-icon,\n.schedule-calendar .event-container:hover .edit-icon {\n  opacity: 0.9;\n  transform: translateY(0);\n}\n\n/* Week/Day views: trigger icons when hovering the event badge itself */\n.schedule-calendar .rbc-event:hover .delete-icon,\n.schedule-calendar .rbc-event:hover .edit-icon,\n.schedule-calendar .rbc-day-slot .rbc-event:hover .delete-icon,\n.schedule-calendar .rbc-day-slot .rbc-event:hover .edit-icon {\n  opacity: 0.9;\n  transform: translateY(0);\n}\n\n/* Keep icons visible inside tighter event wrappers used in time views */\n.schedule-calendar .rbc-event-content {\n  overflow: visible !important;\n  display: flex !important;\n  align-items: center !important;\n  width: 100% !important;\n}\n\n/* Week/Day: ensure icons are not clipped and can appear on hover */\n.schedule-calendar .rbc-time-view .rbc-event {\n  overflow: visible !important;\n}\n\n.schedule-calendar .rbc-time-view .event-container {\n  width: 100%;\n}\n\n.schedule-calendar .rbc-time-view .event-title {\n  min-width: 0;\n}\n\n.schedule-calendar .rbc-time-view .rbc-event:hover .delete-icon,\n.schedule-calendar .rbc-time-view .rbc-event:hover .edit-icon {\n  opacity: 0.95 !important;\n  transform: translateY(0) !important;\n}\n\n.schedule-calendar .delete-icon:hover,\n.schedule-calendar .edit-icon:hover {\n  opacity: 1 !important;\n}\n\n/* ── Time View ────────────────────────────────── */\n.schedule-calendar .rbc-time-view {\n  border-radius: 12px !important;\n  border: 1px solid rgba(15,23,42,0.08) !important;\n  overflow: hidden !important;\n  background: #fff !important;\n}\n\n.schedule-calendar .rbc-time-view .rbc-allday-cell + .rbc-allday-cell {\n  border-left: 1px solid rgba(15,23,42,0.06) !important;\n}\n\n.schedule-calendar .rbc-time-header {\n  border-bottom: 1px solid rgba(15,23,42,0.07) !important;\n  background: rgba(248,250,252,0.98) !important;\n}\n\n.schedule-calendar .rbc-time-header-content {\n  border-left: 1px solid rgba(15,23,42,0.06) !important;\n}\n\n.schedule-calendar .rbc-time-header > .rbc-row:first-child {\n  border-bottom: 1px solid rgba(15,23,42,0.07) !important;\n}\n\n.schedule-calendar .rbc-timeslot-group {\n  border-bottom: 1px solid rgba(15,23,42,0.05) !important;\n  min-height: 44px !important;\n}\n\n.schedule-calendar .rbc-time-slot {\n  font-size: 0.68rem !important;\n  color: #94a3b8 !important;\n  font-weight: 500 !important;\n}\n\n.schedule-calendar .rbc-day-slot .rbc-time-slot {\n  border-top: 1px solid rgba(15,23,42,0.04) !important;\n}\n\n.schedule-calendar .rbc-time-content {\n  border-top: 1px solid rgba(15,23,42,0.07) !important;\n}\n\n.schedule-calendar .rbc-time-content > * + * > * {\n  border-left: 1px solid rgba(15,23,42,0.06) !important;\n}\n\n.schedule-calendar .rbc-label {\n  padding: 0 10px !important;\n}\n\n/* Current time indicator */\n.schedule-calendar .rbc-current-time-indicator {\n  height: 2px !important;\n  background: #f63d68 !important;\n  opacity: 0.85 !important;\n}\n\n/* ── Agenda View ──────────────────────────────── */\n.schedule-calendar .rbc-agenda-view {\n  border-radius: 12px !important;\n  overflow: hidden !important;\n}\n\n.schedule-calendar .rbc-agenda-view table.rbc-agenda-table {\n  border: 1px solid rgba(15,23,42,0.08) !important;\n  border-radius: 12px !important;\n  overflow: hidden !important;\n  border-collapse: separate !important;\n  border-spacing: 0 !important;\n}\n\n.schedule-calendar .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  padding: 10px 14px !important;\n  font-size: 0.68rem !important;\n  font-weight: 800 !important;\n  letter-spacing: 0.8px !important;\n  text-transform: uppercase !important;\n  color: #94a3b8 !important;\n  background: rgba(248,250,252,0.98) !important;\n  border-bottom: 1px solid rgba(15,23,42,0.07) !important;\n}\n\n.schedule-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n  padding: 10px 14px !important;\n  font-size: 0.82rem !important;\n  vertical-align: middle !important;\n  border-bottom: 1px solid rgba(15,23,42,0.05) !important;\n}\n\n.schedule-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left: 1px solid rgba(15,23,42,0.05) !important;\n}\n\n.schedule-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {\n  border-top: none !important;\n}\n\n.schedule-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr:hover > td {\n  background: rgba(99,102,241,0.04) !important;\n}\n\n.schedule-calendar .rbc-agenda-date-cell {\n  font-weight: 700 !important;\n  font-size: 0.78rem !important;\n  color: #334155 !important;\n  white-space: nowrap !important;\n}\n\n.schedule-calendar .rbc-agenda-time-cell {\n  font-size: 0.75rem !important;\n  color: #334155 !important;\n  font-weight: 600 !important;\n  white-space: nowrap !important;\n  text-transform: none !important;\n}\n\n.schedule-calendar .rbc-agenda-event-cell {\n  width: 100% !important;\n}\n\n.schedule-calendar .rbc-agenda-event-cell .rbc-event {\n  color: #ffffff !important;\n}\n\n.schedule-calendar .rbc-agenda-event-cell .event-title {\n  color: #ffffff !important;\n}\n\n/* \"Não há agendamentos\" empty state */\n.schedule-calendar .rbc-agenda-empty {\n  padding: 32px !important;\n  text-align: center !important;\n  font-size: 0.85rem !important;\n  color: #94a3b8 !important;\n}\n\n/* ── Overlay (popup for +N more) ─────────────── */\n.schedule-calendar .rbc-overlay {\n  border-radius: 12px !important;\n  border: 1px solid rgba(15,23,42,0.1) !important;\n  box-shadow: 0 16px 40px rgba(15,23,42,0.14) !important;\n  padding: 10px !important;\n  background: #fff !important;\n}\n\n.schedule-calendar .rbc-overlay-header {\n  font-size: 0.75rem !important;\n  font-weight: 700 !important;\n  padding: 4px 8px 8px !important;\n  border-bottom: 1px solid rgba(15,23,42,0.07) !important;\n  margin: -8px -8px 8px !important;\n  color: #475569 !important;\n}\n\n/* ── Mobile ───────────────────────────────────── */\n@media (hover: none), (pointer: coarse) {\n  .schedule-calendar .delete-icon,\n  .schedule-calendar .edit-icon {\n    opacity: 0.9;\n    transform: translateY(0);\n  }\n\n  .schedule-calendar .event-title {\n    font-size: 0.7rem;\n  }\n}\n\n@media (max-width: 599px) {\n  .schedule-calendar .rbc-toolbar {\n    flex-direction: column !important;\n    align-items: stretch !important;\n    gap: 6px !important;\n  }\n\n  .schedule-calendar .rbc-toolbar .rbc-toolbar-label {\n    order: -1 !important;\n    font-size: 0.88rem !important;\n  }\n\n  .schedule-calendar .rbc-btn-group {\n    justify-content: center !important;\n    flex-wrap: wrap !important;\n  }\n\n  .schedule-calendar .rbc-toolbar button {\n    height: 30px !important;\n    padding: 0 9px !important;\n    font-size: 0.7rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
